import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfTranscriptIconProps extends SvgIconProps {}
/**
 * component used to display transcript icon in interaction space header
 * @param props - CcfTranscriptIconProps
 * @example - <CcfTranscriptIcon />
 * @returns SVG of transcript icon in interaction space header
 */
export function CcfTranscriptIcon(props: CcfTranscriptIconProps) {
  return (
    <SvgIcon {...props}>
      <g id="ic_transcript" clip-path="url(#clip-ic_transcript)">
          <g id="Group_112010" data-name="Group 112010" transform="translate(-861 -61.5)">
            <g id="Group_119273" data-name="Group 119273" transform="translate(-2221.409 4376.591)">
              <line id="Line_1160" data-name="Line 1160" x2="4.507" transform="translate(3089.505 -4308.896)" fill="none" stroke="#000" strokeLinecap="round" strokeWidth="1"/>
              <line id="Line_1161" data-name="Line 1161" x2="4.507" transform="translate(3089.505 -4306.87)" fill="none" stroke="#000" strokeLinecap="round" strokeWidth="1"/>
              <line id="Line_1162" data-name="Line 1162" x2="2.676" transform="translate(3089.437 -4304.841)" fill="none" stroke="#000" strokeLinecap="round" strokeWidth="1"/>
              <path id="Path_14406" data-name="Path 14406" d="M7.465,4A1.741,1.741,0,0,0,5.732,5.732v8.085H4v2.31a1.741,1.741,0,0,0,1.732,1.732h8.1a1.742,1.742,0,0,0,1.714-1.732V8.042h2.31V5.732A1.741,1.741,0,0,0,16.127,4Zm0,1.155H14.5a1.705,1.705,0,0,0-.108.577V16.127a.577.577,0,0,1-1.155,0l-.018-2.31H6.887V5.732A.568.568,0,0,1,7.465,5.155Zm8.662,0a.568.568,0,0,1,.577.577V6.887H15.55V5.732A.568.568,0,0,1,16.127,5.155ZM5.155,14.972h6.93v1.173a1.661,1.661,0,0,0,.108.559H5.732a.568.568,0,0,1-.577-.577Z" transform="translate(3081.082 -4315.771)"/>
            </g>
          </g>
        </g>
    </SvgIcon>
  );
}

export default CcfTranscriptIcon;
